/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AddOrganizationCreateRequestRequestBeneficialOwnersInner } from './add-organization-create-request-request-beneficial-owners-inner';
// May contain unused imports in some cases
// @ts-ignore
import { AddOrganizationCreateRequestRequestCorporateType } from './add-organization-create-request-request-corporate-type';
// May contain unused imports in some cases
// @ts-ignore
import { AddOrganizationCreateRequestRequestOrganizationUsersInner } from './add-organization-create-request-request-organization-users-inner';
// May contain unused imports in some cases
// @ts-ignore
import { AddOrganizationCreateRequestRequestVcCooperationPlanRewardType } from './add-organization-create-request-request-vc-cooperation-plan-reward-type';

/**
 * 
 * @export
 * @interface AddOrganizationCreateRequestRequest
 */
export interface AddOrganizationCreateRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'corporateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'businessDescriptionId': string;
    /**
     * 
     * @type {number}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'purposeTransactionOther'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'bankAccountType': AddOrganizationCreateRequestRequestBankAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'bankAccountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'bankAccountHolder': string;
    /**
     * 
     * @type {Array<AddOrganizationCreateRequestRequestOrganizationUsersInner>}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'organizationUsers': Array<AddOrganizationCreateRequestRequestOrganizationUsersInner>;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'vcCooperationPlan': string;
    /**
     * 
     * @type {AddOrganizationCreateRequestRequestVcCooperationPlanRewardType}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'vcCooperationPlanRewardType'?: AddOrganizationCreateRequestRequestVcCooperationPlanRewardType | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'promotionCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {AddOrganizationCreateRequestRequestCorporateType}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'corporateType'?: AddOrganizationCreateRequestRequestCorporateType | null;
    /**
     * 
     * @type {Array<AddOrganizationCreateRequestRequestBeneficialOwnersInner>}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'beneficialOwners'?: Array<AddOrganizationCreateRequestRequestBeneficialOwnersInner> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'preRequestCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'mediaCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'campaignApplicationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'identificationId'?: string | null;
}

export const AddOrganizationCreateRequestRequestBankAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type AddOrganizationCreateRequestRequestBankAccountTypeEnum = typeof AddOrganizationCreateRequestRequestBankAccountTypeEnum[keyof typeof AddOrganizationCreateRequestRequestBankAccountTypeEnum];


